export default __webpack_public_path__ + "static/media/img3.753498d3.svg";